<template>
    <div class="main">
        <v-container fluid class="py-0">
            <div class="mt-2">
                <small v-cloak>
                    <i v-cloak>{{ instalationData ? '(' + instalationData.idNInstalacion + ') ' + instalationData.fldTCodigo + ' ' + instalationData.fldTNombre + ' \\ ' + elementData.fldTNombre +' \\ Vista global' : '' }}</i>
                </small>
            </div>
        </v-container>
        <v-container fluid class="py-0" data-html2canvas-ignore="true">
            <v-row justify="start">
                <v-btn class="ma-2 ml-3 mt-4 mb-6" small color="accent" dark @click="createPDF">
                    PDF
                    <v-icon dark right>mdi-adobe-acrobat</v-icon>
                </v-btn>
            </v-row>
        </v-container>
        <v-container fluid class="pa-0">
            <v-expansion-panels focusable multiple class="ml-3 modulo" v-model="panels">
                <v-expansion-panel class="mb-3">
                    <v-expansion-panel-header class="panel-b v-system-bar cb theme--dark" color="blue darken-2" dark>
                        <v-avatar size="24"
                                  tile class="pr-2 mr-2">
                            <img class="ml-1" v-if="elementData.fkNIcono != null && elementData.fkNIcono != 0" :src="elementData.fkNIcono"
                                 aspect-ratio="1"
                                 width="13"
                                 height="13"
                                 contain>
                        </v-avatar>
                        <div>
                            {{elementData.fldTNombre}}
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row dense>
                            <v-container fluid class="d-flex flex-wrap pt-0">
                                <div dense class="d-flex justify-space-between w-250 mr-7 mt-3 hover-bold" v-for="variable in orphanVariables" v-bind:key="variable.idNVariable">
                                    <div class="d-flex align-items-center">
                                        <v-btn small text icon @click="editValue(variable)" v-visible="variable.fldBEscritura">
                                            <v-icon>mdi-lead-pencil</v-icon>
                                        </v-btn>
                                        <v-btn small text icon @click="openGrid(variable)" v-if="variable.fldBGraficable === true">
                                            <v-icon>mdi-chart-line</v-icon>
                                        </v-btn>
                                        <v-btn small text icon @click="openExport(variable)" v-else>
                                            <v-icon>mdi-table-large</v-icon>
                                        </v-btn>
                                        <img class="mr-2 ml-1" v-if="variable.fkNIcono != null && variable.fkNIcono != 0" :src="variable.fkNIcono"
                                             aspect-ratio="1"
                                             width="17"
                                             height="17"
                                             contain>
                                        <div class="lh-25">{{variable.fldTNombre}}</div>
                                    </div>
                                    <!--<div class="lh-25"><strong>{{variable.fldTValor}}</strong></div>-->
                                    <div v-if="variable.fun_Valor_Icono != null && variable.fun_Valor_Icono != 0">
                                        <img class="mr-2 ml-1" v-if="variable.fun_Valor_Icono != null && variable.fun_Valor_Icono != 0" :src="variable.fun_Valor_Icono"
                                             aspect-ratio="1"
                                             width="24"
                                             height="24"
                                             contain>
                                    </div>
                                    <div v-else-if="variable.fldTValor != null && variable.fldTValor != ''" class="lh-25" style="margin-left:15px">{{variable.fldTValor}}</div>
                                    <div v-else class="lh-25" style="margin-left:15px">{{variable.fldTValorNum}}</div>
                                </div>
                            </v-container>


                            <v-card v-cloak width="auto" class="ma-3" style="height: fit-content;" v-for="group in variablesGroup" v-bind:key="group.groupId">
                                <v-system-bar color="blue darken" dark>
                                    <v-spacer>
                                        <v-avatar size="24" tile class="pr-2 mr-2">
                                            <img class="ml-1" v-if="group.variables[0].fldNAgrupacionVariableIcono != undefined && group.variables[0].fldNAgrupacionVariableIcono != null && group.variables[0].fldNAgrupacionVariableIcono != 0"
                                                 :src="group.variables[0].fldNAgrupacionVariableIcono"
                                                 aspect-ratio="1"
                                                 width="13"
                                                 height="13"
                                                 contain>
                                        </v-avatar>
                                        {{ group.variables[0].fldTAgrupacionVariableNombre }}
                                    </v-spacer>
                                </v-system-bar>
                                <v-container fluid>
                                    <div row dense class="d-flex justify-space-between hover-bold" v-for="variable in group.variables" v-bind:key="variable.idNVariable">
                                        <div class="d-flex align-items-center">
                                            <v-btn small text icon @click="editValue(variable)" v-visible="variable.fldBEscritura">
                                                <v-icon>mdi-lead-pencil</v-icon>
                                            </v-btn>
                                            <v-btn small text icon @click="openGrid(variable)" v-if="variable.fldBGraficable === true">
                                                <v-icon>mdi-chart-line</v-icon>
                                            </v-btn>
                                            <v-btn small text icon @click="openExport(variable)" v-else>
                                                <v-icon>mdi-table-large</v-icon>
                                            </v-btn>
                                            <img class="mr-2 ml-1" v-if="variable.fkNIcono != null && variable.fkNIcono != 0" :src="variable.fkNIcono"
                                                 aspect-ratio="1"
                                                 width="17"
                                                 height="17"
                                                 contain>
                                            <div class="lh-25">{{variable.fldTNombre}}</div>
                                        </div>
                                        <div v-if="variable.fun_Valor_Icono != null && variable.fun_Valor_Icono != 0">
                                            <img class="mr-2 ml-1" v-if="variable.fun_Valor_Icono != null && variable.fun_Valor_Icono != 0" :src="variable.fun_Valor_Icono"
                                                 aspect-ratio="1"
                                                 width="24"
                                                 height="24"
                                                 contain>
                                        </div>
                                        <div v-else-if="variable.fldTValor != null && variable.fldTValor != ''" class="lh-25" style="margin-left:15px">{{variable.fldTValor}}</div>
                                        <div v-else class="lh-25" style="margin-left:15px">{{variable.fldTValorNum}}</div>
                                    </div>
                                </v-container>
                            </v-card>

                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-container>
        <template>
            <v-row justify="center">
                <v-dialog persistent v-model="graficos" max-width="500">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>{{ selectedVariable && selectedVariable.fldTNombre }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pb-0">
                            <v-row align="center" class="mx-0 mt-4">
                            </v-row>
                            <div class="my-4 subtitle-1 black--text">
                                <strong>Seleccione un rango de fechas</strong>
                                <v-row>
                                    <v-col sm="6" md="4">
                                        <date-picker v-model="from" format="DD-MM-YYYY HH:mm" type="datetime" :lang="lang" placeholder="Desde"></date-picker>
                                    </v-col>
                                    <v-col sm="6" md="4" class="ml-14">
                                        <date-picker v-model="to" format="DD-MM-YYYY HH:mm" type="datetime" :lang="lang" placeholder="Hasta"></date-picker>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-card-text>

                        <v-card-actions class="px-6 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn text small @click="graficos = false">
                                Cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="goToGrid">
                                Ver Informe
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog persistent v-model="grilla" max-width="500">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>{{ selectedVariable && selectedVariable.fldTNombre }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pb-0">
                            <v-row align="center" class="mx-0 mt-4">
                            </v-row>
                            <div class="my-4 subtitle-1 black--text">
                                <strong>Seleccione un rango de fechas</strong>
                                <v-row>
                                    <v-col sm="6" md="4">
                                        <date-picker v-model="from" format="DD-MM-YYYY HH:mm" v-if="grilla" type="datetime" :lang="lang" placeholder="Desde"></date-picker>
                                    </v-col>
                                    <v-col sm="6" md="4" class="ml-14">
                                        <date-picker v-model="to" format="DD-MM-YYYY HH:mm" v-if="grilla" type="datetime" :lang="lang" placeholder="Hasta"></date-picker>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-card-text>

                        <v-card-actions class="px-6 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn text small @click="grilla = false">
                                Cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="exportData">
                                Exportar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog persistent v-model="tipos" max-width="500">
                    <v-card class="mx-auto" v-if="selectedVariable">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>{{  selectedVariable.fldTNombre }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="pb-0">
                            <v-row align="center" class="mx-0 mt-4">
                            </v-row>
                            <div class="my-4 subtitle-1 black--text">
                                <v-select v-if="selectedVariable.fkNTipoVariableWEB==0"
                                          :items="comboItems"
                                          item-value="fldTCombo"
                                          item-text="fldTCombo"
                                          label="Seleccionar un valor"
                                          :rules="validationRule_Combo"
                                          v-model="selectedVariable.fldTValor">
                                </v-select>
                                <v-text-field v-if=" selectedVariable.fkNTipoVariableWEB == 1" class="pr-2 mx-240" v-model="selectedVariable.fldTValor" label="Valor" outlined dense :rules="validationRule_IntegerNumber"></v-text-field>
                                <v-text-field v-if=" selectedVariable.fkNTipoVariableWEB == 2" class="pr-2 mx-240" v-model="selectedVariable.fldTValor" label="Valor" outlined dense :rules="validationRule_1DecimalNumber"></v-text-field>
                                <v-text-field v-if=" selectedVariable.fkNTipoVariableWEB == 3" class="pr-2 mx-240" v-model="selectedVariable.fldTValor" label="Valor" outlined dense :rules="validationRule_Time"></v-text-field>
                                <v-text-field v-if=" selectedVariable.fkNTipoVariableWEB == 4" class="pr-2 mx-240" v-model="selectedVariable.fldTValor" label="Valor" outlined dense :rules="validationRule_Date"></v-text-field>
                                <v-text-field v-if=" selectedVariable.fkNTipoVariableWEB == 5" class="pr-2 mx-240" v-model="selectedVariable.fldTValor" label="Valor" outlined dense :rules="validationRule_DecimalNumber"></v-text-field>
                            </div>
                        </v-card-text>
                        <v-card-actions class="px-6 pb-6">
                            <v-spacer></v-spacer>
                            <v-btn text small @click="closeValue">
                                Cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="saveValue">
                                Guardar cambios
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
    </div>
</template>

<script>
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    import {
        Component,
        Prop,
        Vue
    } from "vue-property-decorator";
    import InstalationsService from "@/services/InstalationsService";
    import ElementService from '@/services/ElementService';
    import CurrentValueService from "@/services/CurrentValueService"; // ver porqeu no sirve
    import CurrentValueModel from "@/models/CurrentValueModel"; // ver porqeu no sirve
    import UpdateVariableService from "@/services/UpdateVariableService";
    import UpdateVariableModel from "@/models/UpdateVariableModel";
    import ChartService from "@/services/ChartService";
    import jsPDF from 'jspdf';
    import html2canvas from 'html2canvas';
    import 'rasterizehtml';
    import IconModel from '../models/IconModel';
    import IconService from '../services/IconService';
    import ComboVariableService from '@/services/ComboVariableClassService';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    @Component({
        components: {
            DatePicker
        },
        data() {
            return {
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
            };
        },
    })
    export default class Home extends Vue {
        async mounted() {
            await this.loadData();
        }

        instalationData = {};
        elementData = { fldTNombre: null };
        variables = [];
        variablesGroup = [];
        iconList = [];
        selectedVariable = null;
        grilla = false;
        graficos = false;
        from = yesterday; //yesterday.toISOString().substr(0, 10);
        to = today; //today.toISOString().substr(0, 10);
        tipos = false;

        bgFrom = false;
        bgTo = false;
        bhFrom = false;
        bhTo = false;

        panels = [];
        comboItems = [];

        // Validation Rules

        invalidos = ["30/02", "31/02", "31/04", "31/06", "31/09", "31/11"];

        validationRule_Date = [v => !this.invalidos.includes(v) && /(^( [0][1-9](\/)([0][1-9]|[1][0-2]))$|(^([1-2][0-9](\/)([0][1-9]|[1][0-2]))$|^([3][0-1](\/)([0][1-9]|[1][0-2])))$)$/.test(v) || 'Ingrese un dia y mes en formato DD/MM'];
        validationRule_IntegerNumber = [v => /^([0-9]+)$/.test(v) || "Ingrese un numero entero"];
        validationRule_1DecimalNumber = [v => /^([0-9]+(\.|,)[0-9])$/.test(v) || "Ingrese un numero entero con 1 decimal"];
        validationRule_Time = [v => /^([0-1][0-9](:)[0-5][0-9]|[2][0-3](:)[0-5][0-9])$/.test(v) || "Ingrese una hora y minuto en formato HH:mm"]
        validationRule_DecimalNumber = [v => /^([0-9]+(\.)[0-9]+)$/.test(v) || "Ingrese correctamente un numero decimal"];
        validationRule_Combo = [v => !!v || "Seleccione un valor para la variable"];


        async loadData() {
            let idE = this.$route.params.idE;
            let idI = this.$route.params.idI;

            var dataInst = await new InstalationsService().get(idI, null);
            if (dataInst != null) {

                if (dataInst.success == false) {
                    this.showError(dataInst.error);
                }

                this.instalationData = dataInst.instalation;
            }

            var res = await new ElementService().getGlobalData(idI, idE);
            if (res.success) {
                let data = res.data;

                //mapeo elemento
                this.elementData = data.map(x => ({
                    idNElemento: x.idNElemento,
                    fkNSupervisor: x.idNSupervisor,
                    fkNTipoElemento: x.idNTipoElemento,
                    fkNAgrupacionElemento: x.idNAgrupacionElemento,
                    fldTNombre: x.elemento,
                    fldBVisibleEnPortada: true,
                    fldBActivo: true,
                    fkNTipoVariableWEB: x.idNTipoVariableWEB,
                    fkNIcono: x.tipo_Elemento_Icono
                })
                )[0];

                //Set LocalStorage: IconsAll
                await new IconService().setIconsAll(new IconModel());

                //busqueda �cono elemento
                if (this.elementData.fkNIcono != undefined && this.elementData.fkNIcono != null) {
                    /*1.Bloque Comentado
                   var filter1 = new IconModel();
                   filter1.idNIcono = this.elementData.fkNIcono;

                   var resI = await new IconService().list(filter1);
                   if (resI.success) {
                       var iconPath1 = resI.data;
                       if (iconPath1[0] != undefined && iconPath1[0] != null)
                           this.elementData.fkNIcono = iconPath1[0].fldTRuta;
                   }
                   else {
                       this.showError('Ocurrio un error: ' + resI.Message);
                   }
                   */
                    this.elementData.fkNIcono = new IconService().getIconFromStorage(this.elementData.fkNIcono);
                }

                //mapeo variables
                let variableWithGrouping = data.map(x => ({
                    idNVariable: x.idNVariable,
                    fkNTipoVariable: x.idNTipoVariable,
                    fkNElemento: x.idNElemento,
                    fldTNombre: x.variable,
                    fldBLectura: x.variable_Lectura,
                    fldBEscritura: x.variable_Escritura,
                    fkNAgrupacionVariable: x.idNAgrupacionVariable,
                    fldTAgrupacionVariableNombre: x.agrupacion_Variable,
                    fldNAgrupacionVariableIcono: x.agrupacion_Variable_Icono,
                    idNTipoVariable: x.idNTipoVariable,
                    fldTStyle: '',
                    fldTDireccionVariable: '',
                    fldBGraficable: x.tipo_Variable_Graficable,
                    fkNIcono: x.tipo_Variable_Icono,
                    fldTValor: x.valor_Texto,
                    fldTValorOrig: x.valor_Texto,
                    fkNTipoVariableWEB: x.idNTipoVariableWEB,
                    idNSupervisor: x.idNSupervisor,
                    fkNTipoSupervisor: x.tipo_Supervisor,
                    fun_Valor_Icono: x.fun_Valor_Icono
                }));

                var LastGrpIdx = 0;
                var OrderIndex = 0;
                //busqueda �conos variables
                for (let i = 0; i < variableWithGrouping.length; i++) {

                    let e = variableWithGrouping[i];

                    if (LastGrpIdx == 0 || LastGrpIdx != e.fkNAgrupacionVariable) {
                        LastGrpIdx = e.fkNAgrupacionVariable;
                        OrderIndex++;
                    }
                    e.OrderIndex = OrderIndex

                    if (e.fkNIcono != undefined && e.fkNIcono != null) {
                        /* 2. bloqueComenado
                         var filter2 = new IconModel();
                        filter2.idNIcono = e.fkNIcono;

                        var resIc = await new IconService().list(filter2);
                        if (resIc.success) {
                            var iconPath2 = resIc.data;
                            if (iconPath2[0] != undefined && iconPath2[0] != null)
                                e.fkNIcono = iconPath2[0].fldTRuta;
                        }
                        else {
                            //this.showError('Ocurrio un error: ' + resIc.Message);
                            console.log('Ocurrio un error: ' + resIc.Message);
                        } 2.Finbloquecomentado */
                        e.fkNIcono = new IconService().getIconFromStorage(e.fkNIcono);
                    }

                    if (e.fun_Valor_Icono != undefined && e.fun_Valor_Icono != null && e.fun_Valor_Icono > 0) {
                        /*3. bloque comentado
                        var filtervi = new IconModel();
                        filtervi.idNIcono = e.fun_Valor_Icono;

                        var resIcvi = await new IconService().list(filtervi);
                        if (resIcvi.success) {
                            var iconPathvi = resIcvi.data;
                            if (iconPathvi[0] != undefined && iconPathvi[0] != null)
                                e.fun_Valor_Icono = iconPathvi[0].fldTRuta;
                        }
                        else {
                            //this.showError('Ocurrio un error: ' + resIcvi.Message);
                            console.log('Ocurrio un error: ' + resIcvi.Message);
                        }
                        3.finbloque comentado*/
                        e.fun_Valor_Icono = new IconService().getIconFromStorage(e.fun_Valor_Icono);
                    }

                    if (e.fldNAgrupacionVariableIcono != undefined && e.fldNAgrupacionVariableIcono != null && e.fldNAgrupacionVariableIcono > 0) {
                        /*4.Bloquecomentado
                         var filtergi = new IconModel();
                        filtergi.idNIcono = e.fldNAgrupacionVariableIcono;

                        var resIcgi = await new IconService().list(filtergi);
                        if (resIcgi.success) {
                            var iconPathgi = resIcgi.data;
                            if (iconPathgi[0] != undefined && iconPathgi[0] != null)
                                e.fldNAgrupacionVariableIcono = iconPathgi[0].fldTRuta;
                        }
                        else {
                            //this.showError('Ocurrio un error: ' + resIcgi.Message);
                            console.log('Ocurrio un error: ' + resIcgi.Message);
                        }4fin bloque comentado*/

                        e.fldNAgrupacionVariableIcono = new IconService().getIconFromStorage(Number(e.fldNAgrupacionVariableIcono));
                    }

                }

                //Agrupaci�n de variables por campo fkNAgrupacionVariable
                var groups = {};
                var groupId = 0;
                for (var i = 0; i < variableWithGrouping.length; i++) {
                    groupId = variableWithGrouping[i].OrderIndex; //fkNAgrupacionVariable;
                    if (!groups[groupId]) {
                        groups[groupId] = [];
                    }
                    groups[groupId].push(variableWithGrouping[i]);
                }
                variableWithGrouping = [];

                for (var group in groups) {
                    variableWithGrouping.push({ groupId: group, variables: groups[group] });
                }

                this.variablesGroup = variableWithGrouping;

            }
            else {
                this.showError(res.error);
            }

            this.expandAll();
        }

        get orphanVariables() {
            return this.variables.filter(itm => !itm.fkNAgrupacionVariable);
        }

        getVariables(groupId) {
            return this.variables.filter(itm => itm.fkNAgrupacionVariable == groupId);
        }

        async editValue(variable) {
            this.selectedVariable = variable;
            if (this.selectedVariable.fkNTipoVariableWEB == 1 || this.selectedVariable.fkNTipoVariableWEB == 2 || this.selectedVariable.fkNTipoVariableWEB == 5) { //Para valors numericos, seteo en null
                this.selectedVariable.fldTValor = null;
            }
            if (variable.fkNTipoVariableWEB == 0) {

                var res = await new ComboVariableService().list({ fkNTipoVariable: variable.idNTipoVariable });
                if (res.success) {
                    this.comboItems = res.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + res.Message);
                }

            }
            this.tipos = true;
        }

        openGrid(variable) {
            this.selectedVariable = variable;
            this.graficos = true;
        }

        openExport(variable) {
            this.selectedVariable = variable;
            this.grilla = true;
        }

        goToGrid() {
            let routeData = this.$router.resolve({
                name: 'Graficas', //No cambiar ni colocar acento
                params: {
                    idI: this.$route.params.idI,
                    idE: this.selectedVariable.fkNElemento,
                    idV: this.selectedVariable.idNVariable,
                    f: this.from,
                    t: this.to
                }
            });
            window.open(routeData.href, '_blank');
            this.graficos = false;
        }

        expandAll() {
            this.panels = [];
            this.panels.push(0);
        }

        closeValue() {
            this.selectedVariable.fldTValor = this.selectedVariable.fldTValorOrig;
            this.selectedVariable = null;
            this.tipos = false;
        }

        async saveValue() {
            if (this.selectedVariable) {
                var data = new UpdateVariableModel();
                data.IdNVariable = this.selectedVariable.idNVariable;
                data.IdNTipoVariableWEB = this.selectedVariable.fkNTipoVariableWEB;
                data.Valor = this.selectedVariable.fldTValor;
                data.IdNTipoVariable = this.selectedVariable.idNTipoVariable;
                data.IdNSupervisor = this.selectedVariable.idNSupervisor;
                data.IdNTipoSupervisor = this.selectedVariable.fkNTipoSupervisor;
                if (this.selectedVariable.fkNTipoVariableWEB == 2) {
                    //deberia reemplazar ',' por '.'
                    data.Valor = data.Valor.replace(/,/g, '.')
                }
                var res = await new UpdateVariableService().update(data);

                if (res.success == false) {
                    this.showError(res.message);
                }

                // TODO Revisar si CurrentValue es Valido sino borrar SPs,Servicios, etc
                /*var data = new CurrentValueModel();
                data.fkNVariable = this.selectedVariable.idNVariable;
                data.fldDFechaSupervisor = new Date();
                data.fldDInsert = new Date();
                data.fldDInsertUTF = new Date();
                data.fldTValor = this.selectedVariable.fldTValor;
                await new CurrentValueService().insert(data);*/
                await this.loadData();
            }
            this.closeValue();
        }

        async createPDF() {
            var element = await document.querySelector('.main');

            var pdfOptions = {
                orientation: "landscape", // One of "portrait" or "landscape" (or shortcuts "p" (Default), "l")
                unit: "mm",               // Measurement unit to be used when coordinates are specified. One of "pt" (points), "mm" (Default), "cm", "in"
                format: "a4"              // One of 'a3', 'a4' (Default),'a5' ,'letter' ,'legal'
            };
            const today = new Date();
            // Creamos el pdf
            var doc = new jsPDF(pdfOptions);
            doc.setFillColor(245);
            // Seteamos el Titulo
            doc.text("Elementos Globales", 10, 15);

            var pageWidth = doc.internal.pageSize.width - 20;
            var pageHeight = doc.internal.pageSize.height - 20;

            html2canvas(element, {
                allowTaint: true,
                useCORS: true,
                backgroundColor: "rgba(0,0,0,0)"
            }).then(canvas => {
                var imgWidth = canvas.width;
                var imgHeight = canvas.height;
                // Height alternativo
                var height = (pageWidth * imgHeight) / imgWidth;
                var imgData = canvas.toDataURL('image/png');
                doc.addImage(imgData, 'PNG', 5, 25, pageWidth - 30, 80);
                doc.save('Elemento Global.pdf');
            });
        }

        async exportData() {
            this.grilla = false;
            var nombreElem = '';
            var resEl = await new ElementService().get(this.selectedVariable.fkNElemento);
            if (resEl.success) {
                nombreElem = resEl.element.fldTNombre;
            }

            var nombreInst = this.instalationData.fldTCodigo + ' ' + this.instalationData.fldTNombre;

            var values = [{
                idNInstalacion: this.$route.params.idI,
                idNElements: this.selectedVariable.fkNElemento,
                idNVariable: this.selectedVariable.idNVariable,
                from: this.from,
                to: this.to,
                nombreInstalacion: nombreInst,
                nombreElemento: nombreElem,
                nombreVariable: this.selectedVariable.fldTNombre
            }];

            var res = await new ChartService().GetExcelHistoryData(values);
            if (res.success == false) {
                this.showError(res.message);
                return;
            }
            var data = res.data;

            var fileURL = window.URL.createObjectURL(data);
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Hist\u00F3ricos.xlsx');
            document.body.appendChild(fileLink);
            fileLink.click();
            this.grilla = false;
        }
    }
</script>

<style>
    div.ma-3 {
        margin-bottom: 5px !important;
        animation-duration: 1s;
        animation-iteration-count: 1;
        transform-origin: bottom;
    }

    div.ma-3:hover {
        color: royalblue !important;
        animation-name: bounce;
        animation-timing-function: ease;
    }

    div.ma-3:hover .v-system-bar {
        background-color: royalblue !important;
    }

    @keyframes bounce {
        0% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-5px);
        }

        100% {
            transform: translateY(0);
        }
    }

    div.hover-bold:hover {
        font-weight: 900;
    }
</style>
